import App from '../../App'
import {html, render } from 'lit-html'
import {gotoRoute, anchorRoute} from '../../Router'
import Auth from '../../Auth'
import Utils from '../../Utils'
import ProviderAPI from '../../ProviderAPI'
import Toast from '../../Toast'
import 'animate.css';

class hiredWorkersView {
  init(){
    document.title = 'Services'    
    this.provider = null
    this.render()    
    Utils.pageIntroAnim()
    this.getProviders()
  }

  
  async getProviders(){
    try{
      this.provider = await ProviderAPI.getProviders()
      console.log(this.provider)
      this.render()
    }catch(err){
      Toast(err, 'error')
    }
  }

  hiredWorkers(){
    //create sl-dialog
    const dialogEl= document.createElement('sl-dialog')
    //add a className
    dialogEl.className ='provider-dialog'
    //sl-dialog content
    const dialogContent = html`

    <style>


    .profile-content-container{
      width: 90%;
     
    }


    .profile-content-info{
      text-align: left;
    }

    sl-dialog{
      --width: 50%;
     
    }

    sl-dialog::part(body){
      height: 450px;
     
    }

    .project{
      margin-left: 60%;
      width: 40%;
      margin-bottom: 2%;
    }


    /*-----------RESPONSIVE-----------------*/
    @media all and (max-width: 1024px){       
        
      sl-dialog{
        --width: 70%;
       
      }
  
      .project{
        margin-left: 50%;
        width: 40%;
        margin-bottom: 2%;
      }
  
      
    }
      
    
    
    </style>


    <div class="activejobs">

          <div id="profile-content">

                  

          <div class="profile-content-container">

              <div class="profile-content-titles">
                <p >Workers Name</p>
                <p> Phone Number</p>
                <p> Email</p>
                <p>Address</p>  
                <p class="active-title">Client Budget</p>
                <p class="active-title">Schedule</p>
                <p class="active-title">Message</p>
              
            </div>


                <div class="profile-content-info">
                      <p >Robert Ah  Youn </p>
                      <p> 5 490 2421</p>
                      <p>24, Curchill St, Grand Baie</p>
                      <p>robertahyoun@gmail.com</p>
                      <p class="active-subtitle">Rs 10,000 </p> 
                      <p class="active-subtitle">20th October 2022</p>  

                      
                      <p class="active-subtitle"> Hi Nina, 

                      I am glad you sent me your quotation, so for the reviewed budget, the pipes and the materials will cost a bit more than expected that is why your budget has been reviewed, don’t hesitate to contact me,if you’re okay then we can begin the project on the chosen schedule.
                      
                      Robert Ah Youn  </p>   

                      
                      
                      
              </div>

        </div>


        </div>

        <div class="hiredbox"  >
      
      
      
      </div>

      





    <sl-button class="project"  href="/"  type="primary" >PROCEED TO PROJECT</sl-button>
    <sl-button class="project"  href="/hiredworkers"  type="default" >CANCEL</sl-button>

    
    `

    render(dialogContent,dialogEl)

    //append to body
    document.body.append(dialogEl)

    //show dialog
    dialogEl.show()



    //on hide delete dialog
    dialogEl.addEventListener('sl-after-hide', ()=> dialogEl.remove())

  }




  render(){
    const template = html`
      <va-app-header-blk  title="Services" user="${JSON.stringify(Auth.currentUser)}"></va-app-header-blk>

    <main id="hiredworkers" >


    <div class="hired" >
      <h1 class="hiredtitle"> Hired Workers<h1>
      <div id="hiredbox" class="animate__animated animate__fadeInLeft" @click=${this.hiredWorkers.bind(this)}>
      <p class="active-title">Install new pipes and create drainage system for Samantha Jones</p>
      <p class="active-subtitle">Project begun on 20th June </p>   
      
      </div>

    </div>

    
            
        

            
       <main>


    `
    render(template, App.rootEl)
  }
}


export default new hiredWorkersView()